"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const DesktopDatePicker_1 = require("@mui/x-date-pickers/DesktopDatePicker");
const DesktopTimePicker_1 = require("@mui/x-date-pickers/DesktopTimePicker");
/**
 * Utility function that takes a date object and returns a copy.
 * If the passed in date object is null, then the function returns null.
 * @param date
 * @returns A new date object or null
 */
const nullSafeCopy = (date) => (date === null ? null : new Date(date.getTime()));
function DateTimePickerGrid(props) {
    const { disabled, error, helperText, onAccept, onChange, onError, value, DatePickerProps = {}, TimePickerProps = {}, ...gridProps } = props;
    const datePickerProps = (0, react_1.useMemo)(() => ({
        value: nullSafeCopy(value),
        disabled,
        onChange,
        onError,
        onAccept,
        ...DatePickerProps,
        slotProps: {
            ...DatePickerProps.slotProps,
            textField: {
                ...DatePickerProps.slotProps?.textField,
                helperText,
                error,
            },
        },
    }), [value, error, disabled, DatePickerProps, helperText, onError, onAccept]);
    const timePickerProps = (0, react_1.useMemo)(() => ({
        value: nullSafeCopy(value),
        disabled,
        onChange,
        onError,
        onAccept,
        ...TimePickerProps,
        slotProps: {
            ...TimePickerProps.slotProps,
            textField: {
                ...TimePickerProps.slotProps?.textField,
                helperText,
                error,
            },
        },
    }), [value, error, disabled, TimePickerProps, helperText, onError, onAccept]);
    return (react_1.default.createElement(Grid_1.default, { container: true, spacing: 2, ...gridProps },
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(DesktopDatePicker_1.DesktopDatePicker, { ...datePickerProps })),
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(DesktopTimePicker_1.DesktopTimePicker, { ...timePickerProps }))));
}
exports.default = DateTimePickerGrid;
